import { BenefitItem, Button, Container, Eyebrow, Rich, Section, SectionTitle } from '@vcn/ui'
import { useContent } from "../content";

export function Together() {
  const { together } = useContent();

  return (
    <Section id="nutzen" className="scroll-mt-20">
      <Container>
        <div className="text-center">
          <Eyebrow>{together.eyebrow}</Eyebrow>
          <SectionTitle className="mt-4">
            {together.title.map((line) => (
              <span key={line} className="block">
                {line}
              </span>
            ))}
          </SectionTitle>
        </div>

        <div className="mt-14 grid gap-10 md:grid-cols-2 md:gap-8">
          {together.columns.map((column) => (
            <div key={column.role} className="flex gap-4">
              <p className="vcn-vertical-label shrink-0 self-start pt-1">{column.role}</p>

              <div className="flex grow flex-col">
                <ul className="flex flex-col gap-3">
                  {column.benefits.map((benefit) => (
                    <BenefitItem key={benefit.text}>
                      <Rich text={benefit.text} strong={[benefit.strong]} />
                    </BenefitItem>
                  ))}
                </ul>

                {/* `mt-auto` bringt die Buttons beider Spalten auf eine Höhe,
                    auch wenn die Karten darüber unterschiedlich hoch sind. */}
                <div className="mt-auto flex justify-center pt-8">
                  <Button href={column.cta.href} variant={column.cta.variant}>
                    {column.cta.label}
                  </Button>
                </div>
              </div>
            </div>
          ))}
        </div>
      </Container>
    </Section>
  )
}
